document.addEventListener('DOMContentLoaded', async function() {
  const h2Element = document.querySelector('h2.PRODUCT_ID');

  // Obtiene el handle del producto desde Liquid (asegúrate de que sea correcto)
  // Es importante asegurarse de que h2Element exista antes de acceder a su id
  const productHandle = h2Element ? h2Element.id : null;

  const res = await fetch(`https://arica-id-mini-app.vercel.app/shopify/products/${productHandle}/metafields.json`, {
      method: "GET",
              headers: {
            'Content-Type': 'application/json',
          },
    })

  const data = await res.json()

  const zoom_list = data.metafields.find(m => m.key === "zoom_list")

  const link = document.createElement('a');

  link.href = zoom_list.value;
  link.textContent = "See zoom list";
  link.target = "_blank"

  h2Element.parentNode.insertBefore(link, h2Element.nextSibling);

  console.log(data)
});
